module.exports = __webpack_public_path__ + "img/no_vaccine_infographic.b95cba90.svg";